import { Formbot } from '@goodrx/matisse';
import React, { useCallback, useRef } from 'react';
import { debounce } from 'lodash';
import { AddressForm } from 'app/components/AddressForm';
import { OnboardingField, OnboardingFieldProps } from './OnboardingField';

const Address: React.FunctionComponent<OnboardingFieldProps> = ({ onChange, values: address }) => {
  const addressFormRef = useRef<Formbot>(null);

  const handleAddressChange = useCallback(
    (values: Record<string, any>) => {
      onChange({
        values,
        validate: () => {
          if (!addressFormRef.current) {
            return { valid: false };
          }

          return {
            valid: addressFormRef.current.isValid,
            errorMessage: 'Invalid address.',
          };
        },
      });
    },
    [addressFormRef, onChange]
  );

  return <AddressForm ref={addressFormRef} address={address} onChange={debounce(handleAddressChange, 25)} />;
};

const AddressWrapper: React.FunctionComponent = () => {
  return (
    <OnboardingField errorFieldName="profile" fields={['addressLine1', 'addressLine2', 'city', 'state', 'zip']}>
      {(props) => <Address {...props} />}
    </OnboardingField>
  );
};

export { AddressWrapper as Address };
